import { CircularProgress, Grid2 as Grid, Typography } from '@mui/material'
import { fetchWithToken } from 'hooks/http'
import useAuth from 'hooks/useAuth'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { checkFeatureFlag } from 'types/feature-flag'
import CopyTemplate from './CopyTemplate'

const CopyTemplateV2Redirect: React.FC = () => {
  const { templateId } = useParams<{ templateId: string }>()
  const navigate = useNavigate()
  const { token } = useAuth()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (templateId && token) {
      fetchWithToken(`compensation/templates/${templateId}`, token, null)
        .then((data) => {
          navigate('/admin/templates/create', {
            state: { copyTemplateData: data },
            replace: true,
          })
        })
        .catch((err) => {
          setError(err?.message || 'Failed to load template for copying')
        })
    }
  }, [templateId, token, navigate])

  if (error) {
    return (
      <Grid container spacing={12}>
        <Grid
          size={{ xs: 12 }}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
        >
          <Typography color="error">{error}</Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container spacing={12}>
      <Grid
        size={{ xs: 12 }}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
      >
        <CircularProgress color="primary" />
        <Typography sx={{ ml: 2 }}>Loading template...</Typography>
      </Grid>
    </Grid>
  )
}

const CopyTemplateSwitch: React.FC = () => {
  const { profile, isLoading } = useAuth()

  const useV2 = checkFeatureFlag({ name: 'template_editor_v2', level: 'user' }, profile!, isLoading)

  return useV2 ? <CopyTemplateV2Redirect /> : <CopyTemplate />
}

export default CopyTemplateSwitch
